import React from "react";
import {CanDoForYouCardProps} from "../can-do-for-you/types";
import {useStyles} from "./style";

export const CanDoForYouCard = (props: CanDoForYouCardProps) => {
    const classes = useStyles();

    return (
        <a
            className={classes.canDoYouContainer}
            style={{...(props.color && {backgroundColor: props.color})}}
            href={props.href}
            aria-label="Can do for you"
        >
            {props.img}
            <span className={"h5 regular " + classes.canDoYouText}>
                {props.text}
            </span>
        </a>
    );
};
